'use client';

import { useState } from 'react';

export default function EmbeddedOverlay() {
  const [isConfirmed, setIsConfirmed] = useState(true);

  if (isConfirmed) return null;
  return (
    <div className='fixed top-0 left-0 w-full h-full bg-custom-black/50 z-[1000] flex flex-col items-center justify-center gap-4'>
      <p className='text-white whitespace-pre-line text-center body-16-md'>
        확인 버튼을 누르면,{'\n'} 일정표 내부를 스크롤링 할 수 있습니다.
      </p>
      <button
        className='p-10pxr w-100pxr text-white body-16-md bg-primary rounded-full'
        onClick={() => setIsConfirmed(true)}
      >
        확인
      </button>
    </div>
  );
}
